import styledC from 'styled-components';
import Box from '../Box';
const Flex = styledC(Box).withConfig({
  displayName: "Flex",
  componentId: "sc-1livpsu-0"
})(["display:flex;"]);
export default Flex;
//# sourceMappingURL=Flex.js.map